export class DataModelGetSites {
    utilisateurId: string = "";
    raccourci: boolean = false;
}